import { IComponentBase } from './component.interface.base';

export interface IComponentControlBase extends IComponentBase{
  focus(): void;
}